/** Taux officiel BCEAO : 1 EUR = 655.957 XOF (FCFA) */
export const EUR_TO_FCFA_RATE = 655.957;
/** Taux indicatif : 1 USD ≈ 607 FCFA (dérivé de EUR/USD ~1.08) */
export const USD_TO_FCFA_RATE = 607;

export function currencyReducer(
	state = {
		currency: "",
		eurToFcfaRate: EUR_TO_FCFA_RATE,
		usdToFcfaRate: USD_TO_FCFA_RATE
	},
	{ type, payload }
) {
	switch (type) {
		case "SET_USER_CURRENCY":
			console.log("DEBUG], SET_USER_CURRENCY", state, " >>", payload);
			return {
				currency: payload,
				eurToFcfaRate: state.eurToFcfaRate ?? EUR_TO_FCFA_RATE,
				usdToFcfaRate: state.usdToFcfaRate ?? USD_TO_FCFA_RATE
			};
		case "SET_EUR_FCFA_RATE":
			return {
				...state,
				eurToFcfaRate: typeof payload === "number" && payload > 0 ? payload : state.eurToFcfaRate
			};
		case "SET_USD_FCFA_RATE":
			return {
				...state,
				usdToFcfaRate: typeof payload === "number" && payload > 0 ? payload : state.usdToFcfaRate
			};
		default:
			return state;
	}
}
